module.exports = __webpack_public_path__ + "img/talk.880ea310.svg";